// extracted by mini-css-extract-plugin
export default {"primaryTextArea":"TextArea_primaryTextArea__+Yf7L"};